// let base = require('js-base64').Base64;

// const hostname = window.location.hostname
// const port = window.location.port;
// const isIP=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
// let arr =  hostname.split('.')
// let  isDTYProEnv = !hostname.split('.').splice(3).join('.'); //线上的定制化主题
// let API = arr[0].includes('hrss') || arr[0].includes('wd') ?  `https://hrss-api.${arr.splice(1).join('.')}` : `https://hrss-api.${isDTYProEnv ? arr.splice(1).join('.') : arr.splice(2).join('.')}`
// let API_HOST_CMS;
//
// if(isIP.test(hostname) || !!port){
//     API = 'https://hrss-api.testing3.wdeduc.com';
//     // API = 'https://hrss-api.testing2.wdeduc.com';
//
// } else if (hostname.includes('dev')) {
//     API = 'https://hrss-api.testing3.wdeduc.com';
//     // API = 'https://hrss-api.testing2.wdeduc.com';
//
// }


// const hostname = window.location.hostname
// const port = window.location.port;
// const isIP=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
// let API = `https://hrss-api.${hostname.split('.').splice(1).join('.')}`;
// if(isIP.test(hostname) || hostname.includes('dev') || hostname.includes('localhost') || !!port || hostname.includes('k8s')
//     || hostname.includes('fat')
//     || hostname.includes('uat')
//     || hostname.includes('testing3')
// ){
//     if(hostname.includes('fat')){
//         API = `https://hrss-api.fat.wdeduc.com/`;
//     } else if(hostname.includes('uat')){
//         API = `https://hrss-api.uat.wdeduc.com/`;
//     } else if(hostname.includes('testing3')){
//         API = `https://hrss-api.testing3.wdeduc.com/`;
//     } else {
//         API = `https://hrss-api.testing3.wdeduc.com/`;
//     }
// }
// window.APP_BASE_URL = API ;
//
//
// let confUrl
// confUrl = port? base.encode('67938546.wdn-pc.testing3.wdeduc.com') :  base.encode(hostname);
// const pageUrl = port? '67938546.wdn-pc.testing3.wdeduc.com' : hostname;
// const yingjiURL = window.location.origin;
//
// export default {
//     API,
//     confUrl,
//     pageUrl,
//     yingjiURL,
// };
// export default {
//     API,
//     confUrl,
//     pageUrl,
//     yingjiURL,
//     API_HOST_CMS,
// };




let envArr = ['testing1', 'testing2', 'testing3', 'fat', 'uat'];
let env = window.location.port ? 'fat' : '';
envArr.forEach(d => {
    if (location.hostname.includes(d)) {env = d}
})
let API = env ? `${location.protocol}//hrss-api.${env}.wdeduc.com` : `${location.protocol}//hrss-api.wdeduc.com`;

let base = require('js-base64').Base64;
const hostname = window.location.hostname
const port = window.location.port;
const confUrl = port? base.encode('67938546.saas-pc.testing3.wdeduc.com') :  base.encode(hostname);
const pageUrl = port? '67938546.saas-pc.testing3.wdeduc.com' : hostname;
const yingjiURL = window.location.origin;
export default {
    API,
    confUrl,
    pageUrl,
    yingjiURL,
}
